import React from "react";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import SchoolSummary from "./SchoolSummary";
import "../layout/Spinner.css";
import { Loader } from "semantic-ui-react";

var schoolList = null;

const SchoolList = (props) => {
  var schools = props.schools;

  const onSelectSchool = (schoolId, schoolName, schoolLogo) => {
    props.selectSchool(schoolId, schoolName, schoolLogo);
  };

  if (schools) {
    schoolList = (
      <div className="SchoolListDetail">
        {schools &&
          schools.map((school) => {
            return (
              <SchoolSummary
                school={school}
                selectSchool={onSelectSchool}
                key={school.id}
              />
            );
          })}
      </div>
    );
  }

  if (!isLoaded(schools)) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else {
    return schoolList;
  }
};

const mapStateToProps = (state) => {
  return {
    schools: state.firestore.ordered.schools,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "schools",
      orderBy: ["name", "asc"],
    },
  ])
)(SchoolList);
